// extracted by mini-css-extract-plugin
export default {"productGallery":"iN-z","inQuickShop":"jN-z"};